<template>
  <section class="safe-section">
    <div class="safe-container wrapper">
      <div class="safe-content">
        <img
          src="./../assets/safe.webp"
          class="safe-corner"
          alt="Safe corner decoration"
        />

        <h2 class="safe-heading">
          <span class="safe-heading-primary title big weight-900">{{
            $t("Safe & Secure")
          }}</span>
        </h2>
        <p class="desc desc-20 weight-500 safe-info-text">
          {{
            $t(
              "Our servers feature advanced DDoS protection, automated backups, and encrypted connections, keeping your builds intact and your progress safe."
            )
          }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SafeSection",
};
</script>

<style lang="scss" scoped>
.safe-section {
  position: relative;
  width: 100%;
  overflow: visible;
  padding: 0 16px 250px;
  z-index: 1;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
}

.safe-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.safe-corner {
  position: absolute;
  left: calc(50% - 50px);
  transform: translate(-50%, -50%);
  top: calc(50% - 30px);
  z-index: 2;
  pointer-events: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.safe-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 35px 16px 50px;

  @media (max-width: 1024px) {
    padding: 30px 16px;
  }

  @media (max-width: 768px) {
    padding: 24px 12px;
  }
}

.safe-heading {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 12px;
  text-align: center;

  @media (max-width: 768px) {
    margin-bottom: 32px;
  }
}

.title.safe-heading-primary {
  line-height: 140%;
  @media (max-width: 1024px) {
    font-size: 48px;
    line-height: 1.2;
    margin-bottom: 16px;
  }

  @media (max-width: 768px) {
    font-size: 36px;
    margin-bottom: 12px;
  }
}

.desc.safe-info-text {
  max-width: 690px;
  color: #112a3a;
  text-align: center;
  line-height: 150%;

  @media (max-width: 768px) {
    font-size: 14px;
  }
}
</style>
